import { Box } from '@wix/design-system';
import React, { FC, useCallback, useState } from 'react';
import { useSelector, useStore } from 'react-redux';
import { useParams } from 'react-router-dom';

import { logSingleArticlePresented } from '../../bi';
import { Loader } from '../../common/components/Loader';
import { useAnimation } from '../../common/hooks/useAnimation';
import { useFetchArticle } from '../../common/hooks/useFetchArticle';
import { useOnWidgetExpanded } from '../../common/hooks/useOnWidgetExpanded';
import { selectCurrentArticle } from '../../common/selectors/helpCenter';
import { ArticleContainer } from '../../help-center/components/ArticleContainer';
import { Subtitle } from '../../help-center/components/Subtitle';
import s from './styles.scss';

type ArticleProps = {
  openCategoriesExternally?: boolean;
};

export const Article: FC<ArticleProps> = ({ openCategoriesExternally }) => {
  const store = useStore();
  const { articleId, articleUri } = useParams();
  const article = useSelector(selectCurrentArticle);
  const [subtitleText, setSubtitleText] = useState<undefined | string>(
    undefined,
  );

  const activeAnimation = useAnimation(s.moveInRight, s.moveInLeft, [
    articleId,
    articleUri,
  ]);

  useFetchArticle();

  const onTitleHiddenChange = useCallback(
    (value: boolean) => setSubtitleText(value ? article?.title : undefined),
    [article],
  );

  useOnWidgetExpanded((expanded: boolean) => {
    if (expanded && article) {
      logSingleArticlePresented(store.getState(), article);
    }
  });

  return (
    <Box
      height="100%"
      width="100%"
      direction="vertical"
      className={activeAnimation}
    >
      {article ? (
        <>
          <Subtitle
            text={subtitleText}
            href={article.url}
            articleId={article.id}
          />
          <ArticleContainer
            article={article}
            onTitleHiddenChange={onTitleHiddenChange}
            openCategoriesExternally={openCategoriesExternally}
          />
        </>
      ) : (
        <Loader
          dataHook="article__loader"
          height="100%"
          verticalAlign="middle"
        />
      )}
    </Box>
  );
};
